// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2_EsY","icon":"style_icon__3ql-Z"};